import NavMenu from '../../components/navbar/NavMenu'
import TitleBar from '../../components/navbar/TitleBar'
import TrackAllVehicle from '../../components/vehicle/TrackAllVehicle'


export default function TrackVehiclesPage() {
    return (
        <>
            <TitleBar />
            <NavMenu />
            <TrackAllVehicle />
        </>
    )
}
